import * as moment from "moment";

export class DateUtil {
    public static getDateFromDatePicker(datePickerValue: any, format: string = 'DD/MM/YYYY') {
        const dateValue = moment(datePickerValue);
        return dateValue.isValid() ? dateValue.format(format) : null;
    }
}
